import React, { Component } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { updateUserInfo } from "../../actions/user";
import { Link } from 'react-router-dom';

class Profile extends Component {

  componentDidMount() {
    const { updateUserInfo, connection_id, userDetails } = this.props;
    const options = {
      connection_id,
      mobile_no: userDetails.COM_CONSUMER_MOBILE_NO
    }
    updateUserInfo(options)
  }

  render() {

    const { userDetails, userLoading, presentURL } = this.props;

    if (userLoading)
      return (
        <div className="loading-cls"></div>
      )
    return (
      <div>

        {/*Dashboard section*/}
        <section className="section-b-space">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-6 " style={{width:"100%"}}>
                <div className="dashboard-right">
                  <div className="dashboard" style={{marginBottom:60}}>
                    {/* <div className="page-title">
                      <h2>My Profile</h2>
                    </div> */}
                    <div className="welcome-msg">
                      <h3>Hello, {userDetails.COM_FNAME}</h3>

                    </div>
                    <div className="box-account box-info">
                      {/* <div className="box-head">
                        <h2>Account Information</h2>
                      </div> */}
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="box">
                            <div className="box-title">
                              <h3>Profile</h3>
                              <Link to="profile/edit-user">Edit Profile</Link>
                             
                            </div>
                            <div className="box-content">
                              <form className="theme-form mt-4">
                                <div className="form-row">
                                
                                  <div className="col-md-6 right-padding">
                                    <label htmlFor="f_name">First Name</label>
                                    <input className="form-control" defaultValue={userDetails.COM_FNAME} id="f_name" type="text" readOnly />
                                  </div>
                                  <div className="col-md-6 top-margin-row">
                                    <label htmlFor="l_name">Last Name</label>
                                    <input className="form-control" defaultValue={userDetails.COM_LNAME} id="l_name" type="text" readOnly />
                                  </div>
                                  <div className="col-md-6 top-margin top-margin-row right-padding">
                                    <label htmlFor="email">Email</label>
                                    <input className="form-control" defaultValue={userDetails.COM_EMAIL_ID} id="email" type="text" readOnly />
                                  </div>
                                  <div className="col-md-6 top-margin top-margin-row">
                                    <label htmlFor="mobile">Mobile No</label>
                                    <input className="form-control" defaultValue={userDetails.COM_CONSUMER_MOBILE_NO} id="mobile" type="text" readOnly />
                                  </div>
                                </div>
                              </form>
                              
                            </div>
                          </div>
                        </div>
                      </div>
                      <div>
                        <br/>
                        <div className="box">
                          <div className="box-title">
                            <h3>Address Book</h3>
                            <Link to="profile/edit-address">Edit Address</Link>
                          </div>
                          <div className="box-content">
                          <div className="row" style={{marginTop: 20}}>
                            <div className="col-sm-6">
                              <h6>Default Shipping Address</h6>
                              {(userDetails.COM_ADDRESS1 && userDetails.COM_PIN && userDetails.COM_TOWN_NAME &&
                                userDetails.COM_STATE_NAME && userDetails.COM_CONTRY_NAME)
                                ? <address>
                                  {userDetails.COM_ADDRESS1}
                                  {(userDetails.COM_ADDRESS2 || userDetails.COM_ADDRESS3) ?
                                    <address>
                                      {userDetails.COM_ADDRESS2}<br />
                                      {userDetails.COM_ADDRESS3}
                                    </address>
                                    : null}
                                  {userDetails.COM_TOWN_NAME}, {userDetails.COM_STATE_NAME},<br />
                                  {userDetails.COM_CONTRY_NAME} - {userDetails.COM_PIN}
                                </address>
                                : 'Your shipping address is not updated. Please go to Edit Addresses to update the same.'}
                              <br />
                              {/* <a href="#">Edit Address</a> */}
                            </div>
                            <div className="col-sm-6">
                              <h6>Default Billing Address</h6>
                              {(userDetails.COM_BILL_TO_ADDRESS1 && userDetails.COM_BILL_TO_PIN && userDetails.COM_BILL_TO_TOWN_NAME &&
                                userDetails.COM_BILL_TO_STATE_NAME && userDetails.COM_BILL_TO_CONTRY_NAME)
                                ? <address>
                                  <div>
                                    {userDetails.COM_BILL_TO_ADDRESS1}
                                    {(userDetails.COM_BILL_TO_ADDRESS2 || userDetails.COM_BILL_TO_ADDRESS3) ?
                                      <address>
                                        {userDetails.COM_BILL_TO_ADDRESS2}<br />
                                        {userDetails.COM_BILL_TO_ADDRESS3}
                                      </address>
                                      : null}
                                    {userDetails.COM_BILL_TO_TOWN_NAME} , {userDetails.COM_BILL_TO_STATE_NAME},<br />
                                    {userDetails.COM_BILL_TO_CONTRY_NAME} - {userDetails.COM_BILL_TO_PIN}
                                  </div>
                                </address>
                                : 'Your shipping address is not updated. Please go to Edit Addresses to update the same.'}
                              <br />
                              {/* <a href="#">Edit Address</a> */}
                            </div>
                          </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      </div>
    )
  }
}

// export default Profile

const mapStateToProps = (state) => ({
  userLoading: state.user.loading,
  userDetails: state.user.user_details,
  connection_id: state.tenant.connection_id,
  presentURL: state.tenant.presentURL,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { updateUserInfo },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Profile);